module.exports = __webpack_public_path__ + "bbee3f2f0e704b4790c1570d43b35c37.svg";